import { render, staticRenderFns } from "./ReturnComponent.vue?vue&type=template&id=6caf85ee&scoped=true"
import script from "./ReturnComponent.vue?vue&type=script&lang=js"
export * from "./ReturnComponent.vue?vue&type=script&lang=js"
import style0 from "./ReturnComponent.vue?vue&type=style&index=0&id=6caf85ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf85ee",
  null
  
)

export default component.exports